import React from 'react';
import Svg from '../Svg';

const IconColors = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C9.23858 3 7 5.23858 7 8C7 10.7614 9.23858 13 12 13C14.7614 13 17 10.7614 17 8C17 5.23858 14.7614 3 12 3ZM5 8C5 4.13401 8.13401 1 12 1C15.866 1 19 4.13401 19 8C19 8.54723 18.9372 9.0798 18.8184 9.59088C21.2804 10.6751 23 13.1357 23 16C23 19.866 19.866 23 16 23C14.5135 23 13.1338 22.5358 12.0001 21.7452C10.8662 22.5362 9.48729 23 8 23C4.13401 23 1 19.866 1 16C1 13.1357 2.71963 10.6751 5.18157 9.59087C5.06279 9.07979 5 8.54723 5 8ZM5.91103 11.4556C4.19233 12.247 3 13.9852 3 16C3 18.7614 5.23858 21 8 21C9.27672 21 10.4417 20.5215 11.3253 19.734C11.331 19.7288 11.3367 19.7237 11.3424 19.7187C12.3601 18.8034 13 17.4764 13 16C13 15.6371 12.9615 15.284 12.8885 14.9441C12.5975 14.981 12.301 15 12 15C9.39074 15 7.11492 13.5724 5.91103 11.4556ZM14.8183 14.4095C14.9372 14.9211 15 15.4537 15 16C15 17.6353 14.4393 19.1396 13.4996 20.3311C14.235 20.7568 15.0885 21 16 21C18.7614 21 21 18.7614 21 16C21 13.9853 19.8077 12.247 18.089 11.4556C17.3477 12.759 16.2 13.8011 14.8183 14.4095Z"
    />
  </Svg>
);

export default IconColors;
